module.exports = __webpack_public_path__ + "img/icb-leo-elite-e@3x.1d69ff1a.png";